
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.975 4.57h14.963M5.135 4.57V2.869c0-.896.709-1.703 1.683-1.703h3.364c.886 0 1.683.717 1.683 1.703V4.57m2.39 0v11.74c0 .896-.708 1.703-1.682 1.703H4.339a1.691 1.691 0 01-1.683-1.703V4.571h11.6zM6.818 8.693v5.02M10.184 8.693v5.02","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    